<template>
  <div
    class="flex w-full items-start gap-[20px] border-b-[0.5px] border-[rgba(5,21,36,0.06)] py-[24px]"
    aria-hidden="true"
  >
    <div class="h-[120px] w-[213px] shrink-0 animate-pulse rounded-[8px] bg-[#f1f2f4]"></div>

    <div class="flex min-w-0 flex-1 flex-col gap-[12px]">
      <div class="flex h-[52px] flex-col gap-[8px]">
        <span class="h-[20px] w-full animate-pulse rounded-[4px] bg-[#f1f2f4]"></span>
        <span class="h-[20px] w-[72%] animate-pulse rounded-[4px] bg-[#f1f2f4]"></span>
      </div>

      <div class="flex h-[22px] items-center gap-[8px]">
        <span class="h-[22px] w-[56px] shrink-0 animate-pulse rounded-[2px] bg-[#f1f2f4]"></span>
        <span class="size-[20px] shrink-0 animate-pulse rounded-[4px] bg-[#f1f2f4]"></span>
        <span class="h-[16px] w-[96px] animate-pulse rounded-[4px] bg-[#f1f2f4]"></span>
      </div>

      <div class="flex h-[22px] items-center justify-between gap-[8px]">
        <div class="flex min-w-0 items-center gap-[4px]">
          <span class="size-[20px] shrink-0 animate-pulse rounded-[4px] bg-[#f1f2f4]"></span>
          <span class="h-[16px] w-[128px] animate-pulse rounded-[4px] bg-[#f1f2f4]"></span>
        </div>
        <span class="h-[16px] w-[88px] shrink-0 animate-pulse rounded-[4px] bg-[#f1f2f4]"></span>
      </div>
    </div>
  </div>
</template>
